<template>
  <v-container
    id="formResults"
    fluid
    tag="section"
  >
    <v-card
      flat
      class="card-full-width"
    >
      <v-btn
        tile
        @click="doGetSubmissions"
        color="primary"
      >
        Refresh Submissions
      </v-btn>
    </v-card>
    <v-card
      class="mx-4 px-4 py-4"
    >
      <v-toolbar
        dark
        color="blue darken-3"
        class="mb-1"
      >
        <v-select
          v-model="vueIsProcessed"
          :items="optionsIsProcessed"
          item-text="text"
          item-value="value"
          label="Select"
          persistent-hint
          single-line
          style="max-width: 150px"
        ></v-select>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-spacer></v-spacer>
          <v-select
            v-model="vueFormResultsSortBy"
            flat
            solo-inverted
            hide-details
            :items="optionsSoryBy"
            prepend-inner-icon="mdi-magnify"
            label="Sort by"
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn-toggle
            v-model="sortDesc"
            mandatory
          >
            <v-btn
              large
              depressed
              color="blue"
              :value="false"
            >
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn
              large
              depressed
              color="blue"
              :value="true"
            >
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-toolbar>
      <v-data-table
        :items="formResults"
        :headers="headersFormResults"
        :search="search"
        :sort-by="vueFormResultsSortBy.toLowerCase()"
        :sort-desc="sortDesc"
        :page="page"
        :items-per-page.sync="itemsPerPage"
        fixed-header
        height="600"
      >
        <template v-slot:item.updated_at="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
              {{ formatEpoch(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
              </span>
            </template>
            <p>
              {{ formatEpoch(item.updated_at, 'ddd MMM DD, yyyy HH:mm:ss') }}
            </p>
            <p>{{ formatEpochFromNow(item.updated_at) }}</p>
          </v-tooltip>
        </template>
        <template v-slot:item.created_by="{ item }">
          <v-list-item-content
            v-if="item.created_by === '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            System
          </v-list-item-content>
          <v-list-item-content
            v-else
            class="align-end"
          >
            {{ item.cb_last_name }}, {{ item.cb_first_name}}
          </v-list-item-content>
        </template>
        <template v-slot:item.updated_by="{ item }">
          <v-list-item-content
            v-if="item.created_by === '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            System
          </v-list-item-content>
          <v-list-item-content
            v-else
            class="align-end"
          >
            {{ item.user_last_name }}, {{ item.user_first_name}}
          </v-list-item-content>
        </template>
        <template v-slot:item.form_source="{ item }">
          <v-list-item-content
            v-if="item.fk_form_key === '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            {{ item.form_type }}
          </v-list-item-content>
          <v-list-item-content
            v-else
            class="align-end"
          >
            {{ item.form_source }}
          </v-list-item-content>
        </template>
        <template v-slot:item.form_display_text="{ item }">
          <v-list-item-content
            v-if="item.fk_form_key === '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            {{ item.form }}
          </v-list-item-content>
          <v-list-item-content
            v-else
            class="align-end"
          >
            {{ item.form_display_text }}
          </v-list-item-content>
        </template>
        <template v-slot:item.is_processed="{ item }">
          <v-chip
            v-if="item.is_processed"
            color="green"
            text-color="white"
            style="max-width: 80px"
          >
            Processed
          </v-chip>
          <v-chip
            v-else
            color="red"
            text-color="white"
            style="max-width: 80px"
          >
            Unprocessed
          </v-chip>
        </template>
        <template v-slot:item.fk_account_key="{ item }">
          <v-list-item-content
            v-if="item.fk_account_key !== '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            <v-btn
              text
              :href="'/#/staff/account/' + item.fk_account_key"
              target="_blank"
              color="blue"
            >
              {{ item.acct_external_key + ' - ' + item.acct_display_text }}
            </v-btn>
          </v-list-item-content>
        </template>
        <template v-slot:item._actions="{ item }">
          <v-btn
            class="ma-2 justify-content-start"
            large
            @click="doLoadDetails(item.rowkey)"
          >
            Details
          </v-btn>
        </template>
      </v-data-table>
      <v-overlay :value="formOverlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </v-card>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import {
    FORM_RESULT_GET, FORM_RESULT_GET_MANY,
  } from '@/store/actions.types'
  import { FORM_RESULT_RESET_RESULTS, FORM_RESULT_RESET_RESULT } from '../../../store/mutations.types'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'FormResults',
    mixins: [basicMixin],

    data () {
      return {
        formOverlay: false,
        selectedAccount: {},
        page: 1,
        filter: {},
        sortBy: 'created_at',
        optionsSoryBy: [
          'rowkey',
          'created_at',
        ],
        itemsPerPageArray: [6, 12, 1000],
        optionsIsProcessed: [
          {
            text: '-ALL-',
            value: '-1',
          },
          {
            text: 'NOT Processed',
            value: '0',
          },
          {
            text: 'Processed',
            value: '1',
          },
        ],
        headersFormResults: [
          {
            text: 'Timestamp',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'updated_at',
          },
          {
            text: 'By',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'created_by',
          },
          {
            text: 'Source',
            align: 'start',
            sortable: false,
            groupable: false,
            value: 'form_source',
          },
          {
            text: 'Form',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'form_display_text',
          },
          {
            text: 'Status',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'form_status',
          },
          {
            text: 'processed',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'is_processed',
          },
          {
            text: 'Account',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'fk_account_key',
          },
          {
            text: 'Children',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'children',
          },
          {
            text: 'Action',
            align: 'start',
            sortable: false,
            groupable: false,
            value: '_actions',
          },
        ],

      }
    },
    computed: {
      ...mapGetters(['formResult', 'formResults', 'formResultsFilter', 'formResultsSortBy', 'formResultsSortDesc', 'formResultsPageSize']),
      numberOfPages () {
        return Math.ceil(this.formResults.length / this.itemsPerPage)
      },
      vueIsProcessed: {
        get () {
          return this.formResultsFilter.is_processed
        },
        set (val) {
          this.$store.commit('SAVE_IS_PROCESSED', val)
          this.getFormResults(this.formResultsFilter)
        },
      },
      search: {
        get () {
          return this.formResultsFilter.search
        },
        set (val) {
          this.$store.commit('SAVE_FILTER_SEARCH', val)
          // this.getFormResults(this.formResultsFilter)
        },
      },
      sortDesc: {
        get () {
          return this.formResultsSortDesc
        },
        set (val) {
          this.$store.commit('SAVE_SORT_DESC', val)
          // this.getFormResults(this.formResultsFilter)
        },
      },
      itemsPerPage: {
        get () {
          return this.formResultsPageSize
        },
        set (val) {
          this.$store.commit('SAVE_PAGE_SIZE', val)
          // this.getFormResults(this.formResultsFilter)
        },
      },
      vueFormResultsSortBy: {
        get () {
          return this.formResultsSortBy
        },
        set (val) {
          this.$store.commit('SAVE_FORMRESULTSSORTBY', val)
        },
      },
    },
    async created () {
      await this.doGetSubmissions()
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      ...mapActions({
        getFormResult: FORM_RESULT_GET,
        getFormResults: FORM_RESULT_GET_MANY,
      }),
      ...mapMutations({
        resetResults: FORM_RESULT_RESET_RESULTS,
        resetDetails: FORM_RESULT_RESET_RESULT,
      }),
      async doGetSubmissions () {
        this.formOverlay = true
        this.resetResults()
        try {
          await this.getFormResults(this.formResultsFilter)
        } catch (e) {
          alert('there was an error retrieving the latest form submissions')
          console.log(e)
        }
        this.formOverlay = false
      },
      async doLoadDetails (rowkey) {
        this.resetDetails()

        await this.$router.push(`/staff/form-result/details?rowkey=${rowkey}`)
      },

      nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
      },
      formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
      },
      updateItemsPerPage (number) {
        this.itemsPerPage = number
      },
    },
  }
</script>
